/**
 * Lazily-loaded MGL (Massachusetts General Laws) search singleton.
 * Assets are served from /data (wired during build integration); until loaded,
 * getMglSearch() returns null and statute lookups degrade gracefully.
 */

import { MGLSearch } from '@/core/mgl-search';

let instance: MGLSearch | null = null;
let loading: Promise<MGLSearch | null> | null = null;

export function getMglSearch(): MGLSearch | null {
  return instance;
}

export function loadMglSearch(): Promise<MGLSearch | null> {
  if (instance) return Promise.resolve(instance);
  if (!loading) {
    loading = MGLSearch.load('/data/mgl-index-optimized.json', '/data/mgl-citations.json').then(
      (s) => {
        instance = s;
        return s;
      }
    );
  }
  return loading;
}
